module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.curInput.time,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "时间类型",
      "prop": "type"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.time.select_type),
      expression: "curInput.time.select_type"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请选择时间类型"
    },
    domProps: {
      "value": (_vm.curInput.time.select_type)
    },
    on: {
      "input": function($event) {
        _vm.curInput.time.select_type = $event
      }
    }
  }, _vm._l((_vm.timeType), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否选择范围",
      "prop": "range_status"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.time.range_status),
      expression: "curInput.time.range_status"
    }],
    domProps: {
      "value": (_vm.curInput.time.range_status)
    },
    on: {
      "input": function($event) {
        _vm.curInput.time.range_status = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1,
      "disabled": _vm.typeFixed
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0,
      "disabled": _vm.typeFixed
    }
  }, [_vm._v("否")])])]), _vm._v(" "), (_vm.typeFixed) ? _c('el-form-item', {
    attrs: {
      "label": "是否固定时间间隔",
      "prop": "fixed_step"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.time.fixed_step),
      expression: "curInput.time.fixed_step"
    }],
    domProps: {
      "value": (_vm.curInput.time.fixed_step)
    },
    on: {
      "input": function($event) {
        _vm.curInput.time.fixed_step = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": _vm.TIME_FIXED_STEP_TRUE
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": _vm.TIME_FIXED_STEP_FALSE
    }
  }, [_vm._v("否")])])]) : _vm._e(), _vm._v(" "), (_vm.typeFixed && _vm.isFixedStep) ? _c('el-form-item', {
    attrs: {
      "label": "固定时间间隔",
      "prop": "time_step"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.curInput.time.time_step),
      expression: "curInput.time.time_step",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请填写时间间隔"
    },
    domProps: {
      "value": (_vm.curInput.time.time_step)
    },
    on: {
      "blur": [_vm.setTimeSelectOptions, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        _vm.curInput.time.time_step = (typeof $event === 'string' ? $event.trim() : $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-tips"
  }, [_vm._v("格式：HH:mm（HH代表时，mm代表分），默认值为00:01")])]) : _vm._e(), _vm._v(" "), (!(_vm.typeFixed && !_vm.isFixedStep)) ? _c('el-form-item', {
    attrs: {
      "label": "可选最小值",
      "prop": "time_min"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.time.time_min.type),
      expression: "curInput.time.time_min.type"
    }],
    domProps: {
      "value": (_vm.curInput.time.time_min.type)
    },
    on: {
      "input": function($event) {
        _vm.curInput.time.time_min.type = $event
      }
    }
  }, _vm._l((_vm.limitType), function(item) {
    return _c('el-radio', {
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _vm._v(" "), (_vm.minTypeVar) ? _c('div', [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.curInput.time.time_min.var_limit),
      expression: "curInput.time.time_min.var_limit",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请填写变量限制"
    },
    domProps: {
      "value": (_vm.curInput.time.time_min.var_limit)
    },
    on: {
      "input": function($event) {
        _vm.curInput.time.time_min.var_limit = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.minTypeFixed && (_vm.isFixedStep || !_vm.typeFixed) && _vm.pickerShow) ? _c('div', [_c('el-time-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.time.time_min.fixed_value),
      expression: "curInput.time.time_min.fixed_value"
    }],
    attrs: {
      "format": _vm.format,
      "placeholder": "选择可选最小值"
    },
    domProps: {
      "value": (_vm.curInput.time.time_min.fixed_value)
    },
    on: {
      "input": function($event) {
        _vm.curInput.time.time_min.fixed_value = $event
      }
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!(_vm.typeFixed && !_vm.isFixedStep)) ? _c('el-form-item', {
    attrs: {
      "label": "可选最大值",
      "prop": "time_max"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.time.time_max.type),
      expression: "curInput.time.time_max.type"
    }],
    domProps: {
      "value": (_vm.curInput.time.time_max.type)
    },
    on: {
      "input": function($event) {
        _vm.curInput.time.time_max.type = $event
      }
    }
  }, _vm._l((_vm.limitType), function(item) {
    return _c('el-radio', {
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _vm._v(" "), (_vm.maxTypeVar) ? _c('div', [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.curInput.time.time_max.var_limit),
      expression: "curInput.time.time_max.var_limit",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请填写变量限制"
    },
    domProps: {
      "value": (_vm.curInput.time.time_max.var_limit)
    },
    on: {
      "input": function($event) {
        _vm.curInput.time.time_max.var_limit = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.maxTypeFixed && (_vm.isFixedStep || !_vm.typeFixed) && _vm.pickerShow) ? _c('div', [_c('el-time-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.time.time_max.fixed_value),
      expression: "curInput.time.time_max.fixed_value"
    }],
    attrs: {
      "format": _vm.format,
      "placeholder": "选择可选最大值"
    },
    domProps: {
      "value": (_vm.curInput.time.time_max.fixed_value)
    },
    on: {
      "input": function($event) {
        _vm.curInput.time.time_max.fixed_value = $event
      }
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "默认值",
      "prop": "default_type"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.time.time_default.default_type),
      expression: "curInput.time.time_default.default_type"
    }],
    domProps: {
      "value": (_vm.curInput.time.time_default.default_type)
    },
    on: {
      "input": function($event) {
        _vm.curInput.time.time_default.default_type = $event
      }
    }
  }, _vm._l((_vm.defaultType), function(item) {
    return _c('el-radio', {
      attrs: {
        "label": item.id,
        "disabled": item.id == 20 && _vm.curInput.time.select_type == _vm.TIME_FIXED && _vm.curInput.time.fixed_step == 0
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _vm._v(" "), _vm._v(" "), (_vm.defaultTypeVar && !_vm.isRange) ? _c('div', [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.curInput.time.time_default.single),
      expression: "curInput.time.time_default.single",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请填写公式"
    },
    domProps: {
      "value": (_vm.curInput.time.time_default.single)
    },
    on: {
      "input": function($event) {
        _vm.curInput.time.time_default.single = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), (_vm.defaultTypeVar && _vm.isRange) ? _c('div', [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.curInput.time.time_default.range_start),
      expression: "curInput.time.time_default.range_start",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请填写起始时间公式"
    },
    domProps: {
      "value": (_vm.curInput.time.time_default.range_start)
    },
    on: {
      "input": function($event) {
        _vm.curInput.time.time_default.range_start = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.curInput.time.time_default.range_end),
      expression: "curInput.time.time_default.range_end",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请填写结束时间公式"
    },
    domProps: {
      "value": (_vm.curInput.time.time_default.range_end)
    },
    on: {
      "input": function($event) {
        _vm.curInput.time.time_default.range_end = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), (_vm.typeAnyTime && _vm.defaultTypeFixed && !_vm.isRange) ? _c('div', [_c('el-time-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.time.time_default.fixed_value),
      expression: "curInput.time.time_default.fixed_value"
    }],
    attrs: {
      "picker-options": _vm.timePickerOptions,
      "placeholder": "选择默认值"
    },
    domProps: {
      "value": (_vm.curInput.time.time_default.fixed_value)
    },
    on: {
      "input": function($event) {
        _vm.curInput.time.time_default.fixed_value = $event
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), (_vm.typeAnyTime && _vm.defaultTypeFixed && _vm.isRange) ? _c('div', [_c('el-time-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeRange),
      expression: "timeRange"
    }],
    attrs: {
      "is-range": "",
      "picker-options": _vm.timePickerOptions,
      "placeholder": "选择默认值"
    },
    domProps: {
      "value": (_vm.timeRange)
    },
    on: {
      "input": function($event) {
        _vm.timeRange = $event
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), (_vm.typeFixed && _vm.defaultTypeFixed && _vm.isFixedStep && _vm.pickerShow) ? _c('div', [_c('el-time-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.time.time_default.fixed_value),
      expression: "curInput.time.time_default.fixed_value"
    }],
    attrs: {
      "picker-options": _vm.timeSelectOptions,
      "placeholder": "选择默认值"
    },
    domProps: {
      "value": (_vm.curInput.time.time_default.fixed_value)
    },
    on: {
      "input": function($event) {
        _vm.curInput.time.time_default.fixed_value = $event
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), (_vm.typeFixed && _vm.defaultTypeFixed && !_vm.isFixedStep) ? _c('div', [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.time.time_default.fixed_value),
      expression: "curInput.time.time_default.fixed_value"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请选择默认时间"
    },
    domProps: {
      "value": (_vm.curInput.time.time_default.fixed_value)
    },
    on: {
      "input": function($event) {
        _vm.curInput.time.time_default.fixed_value = $event
      }
    }
  }, _vm._l((_vm.curInput.time.time_config), function(item) {
    return _c('el-option', {
      attrs: {
        "label": _vm.parseTime(item.value),
        "value": item.value
      }
    })
  }))]) : _vm._e(), _vm._v(" ")]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeFixed && !_vm.isFixedStep),
      expression: "typeFixed && !isFixedStep"
    }],
    attrs: {
      "label": "时间选项"
    }
  }, [_vm._l((_vm.curInput.time.time_config), function(item, index) {
    return _c('div', [_c('el-time-picker', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.value),
        expression: "item.value"
      }],
      staticClass: "m-b-10",
      attrs: {
        "format": "HH:mm",
        "placeholder": "选项值"
      },
      domProps: {
        "value": (item.value)
      },
      on: {
        "input": function($event) {
          item.value = $event
        }
      }
    }), _vm._v(" "), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "small",
        "type": "danger"
      },
      on: {
        "click": function($event) {
          _vm.deleteConfig(index)
        }
      }
    }, [_vm._v("删除")])])
  }), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addConfig()
      }
    }
  }, [_vm._v("添加")])])], true), _vm._v(" "), _c('div', {
    staticClass: "form-tips"
  }, [_vm._v("变量公式说明：h代表时，m代表分，s代表秒，+1代表往前加一个单位，-1代表往后减一个单位；使用&进行多公式连接。例：h+1代表一个小时后，m+10代表十分钟后，s+30代表30秒后，支持小数")]), _vm._v(" "), _c('div', {
    staticClass: "h-28"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60e1e10d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/timeConfig.vue
// module id = 1884
// module chunks = 2